import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const saved = localStorage.getItem('biocs_user');
    if (saved) {
      try { setUser(JSON.parse(saved)); } catch { /* ignore */ }
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleGoogleLogin = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!clientId) {
      alert('Google login is not configured.');
      return;
    }
    const redirectUri = window.location.origin + '/';
    const scope = 'openid email profile';
    const url =
      'https://accounts.google.com/o/oauth2/v2/auth' +
      `?client_id=${clientId}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      '&response_type=token&scope=' + encodeURIComponent(scope) +
      '&prompt=select_account';
    window.location.href = url;
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('access_token')) {
      const params = new URLSearchParams(hash.substring(1));
      const token = params.get('access_token');
      if (token) {
        fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${token}` },
        })
          .then(r => r.json())
          .then(data => {
            const userData = {
              name: data.name,
              email: data.email,
              picture: data.picture,
            };
            setUser(userData);
            localStorage.setItem('biocs_user', JSON.stringify(userData));
            window.history.replaceState(null, '', window.location.pathname);
          })
          .catch(() => {});
      }
    }
  }, []);

  const handleLogout = () => {
    setUser(null);
    setShowDropdown(false);
    localStorage.removeItem('biocs_user');
  };

  return (
    <header className="header">
      <Link to="/" className="header-left">
        <div className="logo-container">
          <div className="logo-circle">
            <span className="logo-text">BIOCS</span>
          </div>
        </div>
        <h1 className="header-title">Biosequence Analyzer</h1>
      </Link>
      <div className="header-right">
        {user ? (
          <div className="user-menu" ref={dropdownRef}>
            <button
              className="user-btn"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <img src={user.picture} alt="" className="user-avatar" />
              <span className="user-name">{user.name}</span>
            </button>
            {showDropdown && (
              <div className="user-dropdown">
                <div className="user-dropdown-info">
                  <img src={user.picture} alt="" className="user-dropdown-avatar" />
                  <div>
                    <p className="user-dropdown-name">{user.name}</p>
                    <p className="user-dropdown-email">{user.email}</p>
                  </div>
                </div>
                <hr className="user-dropdown-divider" />
                <button className="user-dropdown-item" onClick={handleLogout}>
                  Sign out
                </button>
              </div>
            )}
          </div>
        ) : (
          <button className="google-login-btn" onClick={handleGoogleLogin}>
            <svg className="google-icon" viewBox="0 0 24 24" width="18" height="18">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </button>
        )}
      </div>
    </header>
  );
}

export default Header;
